import ErrorPageContent from '@/components/molecules/errorPageContent/errorPageContent'
import { device } from '@/components/templates/displays/devices'
import React, { useEffect, useState } from 'react'
import ScrollLock, { TouchScrollable } from 'react-scrolllock'
import styled from 'styled-components'
import access_denied from '@/public/assets/icons/access_denied.svg'
import TopOfPageWithLogo from '@/components/molecules/topOfPageWithLogo/topOfPageWithLogo'
import DesktopDisplayOnly from '@/components/templates/displays/desktopDisplayOnly'
import IpadAndMobileDisplay from '@/components/templates/displays/ipadAndMobileDisplay'
import { platformMenunData } from '@/context/navigation_n_menu_data'
import MobilePlatformMenu from '@/components/molecules/navigation/mobilePlatformMenu'
import GlobalCtx, { IGlobalCtx } from '@/context/global'
import MobileTopHeaderNav from '@/components/atoms/headers/mobileTopHeaderNav'
import posthog from 'posthog-js'

const OverWrapper = styled.div`
    max-width: 1400px;
    height: 100vh;
    margin: 0 auto;
    padding-left: 30px;
    padding-right: 30px;
`
const Wrapper = styled.div`
    display: flex;
    justify-content: center;
`

const Container = styled.div`
    background-color: #fcfcfc;
    margin-top: 20vh;
    @media ${device.beyond_ipad_mobile} {
        height: fit-content;
        padding-bottom: 10px;
        max-width: 800px;
        min-width: 700px;
    }
    @media ${device.mobile_and_ipad} {
        width: 100%;
        height: fit-content;
        padding-bottom: 10px;
    }
`

const NotFound: React.FunctionComponent<{ isGarage?: boolean }> = (props) => {
    const ref: any = React.useRef()
    const [mounted, setMounted] = useState(false)
    useEffect(() => {
        ref.current = document.getElementById('mobile_platform_menu')
        setTimeout(() => setMounted(true), 50)

        // // The return block goes within useEffect().
        // return function cleanUp() {
        //     ref.current = false;
        //     return
        // }
    }, [])

    const globalCtx: IGlobalCtx = React.useContext(GlobalCtx)

    let onCrossClick = () => {
        if (globalCtx.isPlatformMenuOpen) {
            globalCtx.togglePlatformMenu(false)
            return
        } else if (!globalCtx.isPlatformMenuOpen) {
            globalCtx.togglePlatformMenu(true)
            posthog.capture('public viewer opens platform menu from mobile')
            return
        }
        return
    }

    return (
        <OverWrapper>
            <DesktopDisplayOnly>
                <TopOfPageWithLogo />
                <Wrapper>
                    <ScrollLock />
                    <Container>
                        <ErrorPageContent
                            onClick={() => {}}
                            title={
                                props.isGarage
                                    ? 'Oops, you do not have access to this digital garage.'
                                    : `‘Oops, you do not have access to this car profile.`
                            }
                            subTitle={
                                'Please check the link or ask the Custodian member for access.'
                            }
                            headIcon={access_denied.src}
                        />
                    </Container>
                </Wrapper>
            </DesktopDisplayOnly>
            <IpadAndMobileDisplay>
                <div style={{ padding: '20px' }}>
                    <MobileTopHeaderNav
                        carid={''}
                        garageid={''}
                        isOpen={globalCtx.isPlatformMenuOpen}
                        onCrossClick={onCrossClick}
                    />
                    {mounted && (
                        <TouchScrollable>
                            <div id="mobile_platform_menu">
                                <MobilePlatformMenu
                                    isOpen={globalCtx.isPlatformMenuOpen}
                                    menu_data={platformMenunData}
                                    onCrossClick={onCrossClick}
                                />
                            </div>
                        </TouchScrollable>
                    )}
                    <Container>
                        <ErrorPageContent
                            onClick={() => {}}
                            title={
                                props.isGarage
                                    ? 'Oops, you do not have access to this digital garage.'
                                    : `‘Oops, you do not have access to this car profile.`
                            }
                            subTitle={
                                'Please check the link or ask the Custodian member for access.'
                            }
                            headIcon={access_denied.src}
                        />
                    </Container>
                </div>
            </IpadAndMobileDisplay>
        </OverWrapper>
    )
}

export default NotFound
